import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CreateDropPart } from "@/entities/IDrop";
import { AnimatePresence, motion } from "framer-motion";
import FilePreview from "./FilePreview";
import { UploadingFile } from "./CreateDropContent";
enum FileSource {
  Files,
  Parts,
}
interface FileWithSource {
  file: File;
  source: FileSource;
  label: string | null;
  partIndex?: number;
}
interface CreateDropContentFilesProps {
  readonly parts: CreateDropPart[];
  readonly files: File[];
  readonly uploadingFiles: UploadingFile[];
  readonly removeFile: (file: File, partIndex?: number) => void;
  readonly disabled: boolean;
}
export const CreateDropContentFiles: React.FC<CreateDropContentFilesProps> = t0 => {
  const $ = _c(14);
  const {
    parts,
    files,
    uploadingFiles,
    removeFile,
    disabled
  } = t0;
  let t1;
  if ($[0] !== files || $[1] !== parts) {
    let t2;
    if ($[3] !== parts.length) {
      t2 = (part, index) => part.media.map(file => ({
        file,
        source: FileSource.Parts,
        label: parts.length ? `Part ${index + 1}` : null,
        partIndex: index
      }));
      $[3] = parts.length;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== parts.length) {
      t3 = file_0 => ({
        file: file_0,
        source: FileSource.Files,
        label: parts.length ? `Part ${parts.length + 1}` : null
      });
      $[5] = parts.length;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t1 = [...parts.flatMap(t2), ...files.map(t3)];
    $[0] = files;
    $[1] = parts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const allFiles = t1;
  let t2;
  if ($[7] !== allFiles || $[8] !== disabled || $[9] !== removeFile || $[10] !== uploadingFiles) {
    t2 = !!allFiles.length && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: "auto"
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3
    }}><FilePreview files={allFiles.map(_temp)} uploadingFiles={uploadingFiles} removeFile={file_1 => {
        const fileWithSource_0 = allFiles.find(f => f.file === file_1);
        if (fileWithSource_0) {
          removeFile(file_1, fileWithSource_0.partIndex);
        }
      }} disabled={disabled} /></motion.div>;
    $[7] = allFiles;
    $[8] = disabled;
    $[9] = removeFile;
    $[10] = uploadingFiles;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <div><AnimatePresence>{t2}</AnimatePresence></div>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
function _temp(fileWithSource) {
  return {
    file: fileWithSource.file,
    label: fileWithSource.label
  };
}